export default __webpack_public_path__ + "static/media/CZ-256ESMC3.747816a8.jpg";